module.exports = __webpack_public_path__ + "static/media/svg-5.494b2abd.svg";